import { createOsAuth } from '@os/auth-client';

export const APP_ID = 'shikkahsetu';
export const auth = createOsAuth({
  issuer: (import.meta.env.VITE_OS_ISSUER as string | undefined) ?? 'http://localhost:4100',
  clientId: (import.meta.env.VITE_OS_CLIENT_ID as string | undefined) ?? APP_ID,
  devBypass: (import.meta.env.VITE_AUTH_DEV as string | undefined) === 'true',
});
export const OS_URL = (import.meta.env.VITE_OS_WEB as string | undefined) ?? 'http://localhost:4200';
